import { render } from "./CallToAction.vue?vue&type=template&id=665e03fd&scoped=true"
import script from "./CallToAction.vue?vue&type=script&lang=js"
export * from "./CallToAction.vue?vue&type=script&lang=js"

import "./CallToAction.vue?vue&type=style&index=0&id=665e03fd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665e03fd"]])

export default __exports__